import {
  MediaType,
  UserBookingDetailsQuery,
} from '@website/types/graphqlOperations';
import { DateTime } from 'luxon';
import Link from 'next/link';
import { Alert, Col } from 'react-bootstrap';
import TripPhotosGallery from './utils/TripPhotosGallery';

type Props = {
  media: UserBookingDetailsQuery['booking']['group']['media']['items'];
  group: Pick<UserBookingDetailsQuery['booking']['group'], 'id' | 'start'>;
};

export default function TripPhotos({ media, group }: Props): JSX.Element {
  const isInThePast =
    DateTime.fromISO(group?.start.utc, { zone: 'utc' }).diffNow().as('days') <
    1;

  //  If the trip is more than a day out, tell people they can share photos
  //  after the trip.
  if (!isInThePast) {
    return (
      <>
        <div className="text-block">
          <h5 className="mb-3">Trip Photos</h5>
          <Alert variant="info">
            Everyone can share photos here, once the trip starts.
          </Alert>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="text-block">
        <h5 className="mb-3">Trip Photos</h5>
        <Col xs={12} md="auto">
          {media?.length > 0 ? (
            <Col xs={12} md="auto" className="d-flex p-2">
              <TripPhotosGallery
                images={media
                  .filter((m) => m.type === MediaType.IMAGE)
                  .slice(0, 3)}
                groupID={group.id}
              />
            </Col>
          ) : (
            <>
              <Alert variant="warning">
                <Link passHref href={`/guest/photos/${group.id}`}>
                  No photos have been uploaded! Please upload your photos here
                </Link>
              </Alert>
            </>
          )}
        </Col>
      </div>
    </>
  );
}
